export default "__VITE_ASSET__D72$aV6d__"